import ROUTES from '@lib/constants/routes';
import Link from 'next/link';
import { Elements } from 'prismic-reactjs';
import React, { ReactNode } from 'react';
import { PrismicDocumentType } from '.';

interface Doc {
  type: PrismicDocumentType;
  uid: string;
  url?: string;
}

const getPathByDoc = (doc: Doc) => {
  const map: Record<PrismicDocumentType, string> = {
    blog_home: ROUTES.blog,
    post: ROUTES.blogPost(doc.uid),
    category: ROUTES.blogCategory(doc.uid),
    insurance_term: ROUTES.insuranceTerm(doc.uid),
    seguropedia: ROUTES.insuropedia,
    homepage: ROUTES.root,
    insurance_page: `/${doc.uid}`,
    insurance_carrier: ROUTES.insuranceCarrier(doc.uid),
    carriers: ROUTES.insuranceCarriers,
    vehicle_brand: ROUTES.insurancePage.brand('seguro-carro', doc.uid),
    privacy_policy: ROUTES.privacy,
  };

  const path = map[doc.type];

  return path || doc.url || '/';
};

// -- Link resolution rules
// Manages the url links to internal Prismic documents
export const linkResolver = (doc?: Doc) => {
  if (!doc) return '/';

  return getPathByDoc(doc);
};

export function generateIdByText(text: string) {
  return text.replace(/\W+/g, '-').toLowerCase();
}

export const customLink = (
  _?: unknown,
  element?: { data: Doc },
  content?: string | null,
  __?: unknown,
  index?: string | number,
) => {
  if (element?.data.type) {
    return (
      <Link key={index} href={linkResolver(element?.data)}>
        <a>{content}</a>
      </Link>
    );
  }

  const url = element?.data.url ? new URL(element?.data.url) : null;

  if (url?.host.startsWith('luna.ac')) {
    return (
      <Link key={index} href={url.pathname}>
        <a>{content}</a>
      </Link>
    );
  }

  return (
    <a key={index} href={url?.href} target="_blank" rel="noreferrer">
      {content}
    </a>
  );
};

export const htmlSerializer = (
  type: Elements,
  element: any,
  text: string,
  children: ReactNode[],
  key?: any,
) => {
  if (type === 'heading2') {
    const id = generateIdByText(element.text);

    return (
      <h2 key={`${id}-h2-${element.type}-${key}`} id={id}>
        {children}
      </h2>
    );
  }

  if (type === 'hyperlink') {
    return customLink(type, element, text, children, key);
  }

  return null;
};
